module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAhklEQVQokWN02mnKgAb+owugAUZkLhMBxQQBVQywYWBgeEiE05HBf6geG5ABCxkYGOTIsBykZyELAwODEpoEIw4N2IASCxankQQGRyxQbMA9JD4jkRgG7oEMiGdgYHiMJAgKSHwYBu4zMDAkgmLhCJZ0gCsqYQbA5SkOA/R0gG4TfsDAwAAAUiAYcnjrg5EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn-dy.png
// module id = LD49
// module chunks = 181